/*
 * <collapsible-text> : n'affiche que les N premiers blocs de son contenu et
 * déroule le reste au clic sur le bouton « Voir plus ».
 *
 * Attribut (optionnel) :
 *   data-visible-items   Nombre de blocs visibles à l'état replié (défaut 2)
 *
 * Structure attendue :
 *   <collapsible-text data-visible-items="2">
 *     <div data-collapsible-content>…blocs…</div>
 *     <button type="button" hidden aria-expanded="false"
 *             data-collapsible-toggle data-label-more="…" data-label-less="…"></button>
 *   </collapsible-text>
 *
 * Le bouton est rendu avec l'attribut `hidden` : sans JS, ou si le contenu tient
 * déjà en N blocs, le texte reste affiché en entier et aucun bouton n'apparaît.
 */
class CollapsibleText extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('[data-collapsible-content]');
    this.toggle = this.querySelector('[data-collapsible-toggle]');
    if (!this.content || !this.toggle) return;

    const visibleItems = parseInt(this.dataset.visibleItems, 10) || 2;
    this.hiddenItems = Array.from(this.content.children).slice(visibleItems);
    if (this.hiddenItems.length === 0) return;

    this.collapse();
    this.toggle.hidden = false;
    this.toggle.addEventListener('click', () => {
      if (this.toggle.getAttribute('aria-expanded') === 'true') {
        this.collapse();
      } else {
        this.expand();
      }
    });
  }

  collapse() {
    this.hiddenItems.forEach((item) => item.classList.add('collapsible-text__hidden'));
    this.toggle.setAttribute('aria-expanded', 'false');
    this.toggle.textContent = this.toggle.dataset.labelMore;
  }

  expand() {
    this.hiddenItems.forEach((item) => item.classList.remove('collapsible-text__hidden'));
    this.toggle.setAttribute('aria-expanded', 'true');
    this.toggle.textContent = this.toggle.dataset.labelLess;
  }
}

customElements.define('collapsible-text', CollapsibleText);
